import React, {useState} from "react";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Delete from "@material-ui/icons/Delete";
import FileCopy from "@material-ui/icons/FileCopy";
import {useTranslation} from "react-i18next";
import {useSetRecoilState} from 'recoil';
import {alertState} from '../../../../../../../recoil-store/recoil-state';
import OpenInNew from "@material-ui/icons/OpenInNew";

const options = {
    Cut: <FileCopy style={{fontSize: "18px", marginRight: "5px"}}/>,
    Copy: <FileCopy style={{fontSize: "18px", marginRight: "5px"}}/>,
    Paste: <FileCopy style={{fontSize: "18px", marginRight: "5px"}}/>,
    "Paste Inside": <FileCopy style={{fontSize: "18px", marginRight: "5px"}}/>,
    Delete: <Delete style={{fontSize: "18px", marginRight: "5px"}}/>,
    OpenTab: <OpenInNew style={{fontSize: "18px", marginRight: "5px"}}/>
};

function OptionsMenu(props) {
    const {t} = useTranslation();
    const {index, isCondition, detailTabs, setDetailTabs, item, setDialog} = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const setAlert = useSetRecoilState(alertState);

    const handleClick = (e) => {
        if (!e) var e = window.event;
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const menu = async (option, e) => {
        if (option === "Delete") {
            e.stopPropagation();
            props.options.delete(props.id, item.actionName === 'IF' ? props.condition : undefined);
        } else if (option === "Copy") {
            setAlert(alert => ({...alert, show: true, message: t("MESSAGES.AUTOMS.AUTOM-COPIED"), severity: 'success'}))
            props.options.copy();
        } else if (option === "Cut") {
            e.stopPropagation();
            props.options.cut();
            props.options.delete(true, item.actionName === 'IF' ? props.condition : undefined);
        } else if (option === "Paste") {
            e.stopPropagation();
            props.options.paste();
        } else if (option === 'OpenTab') {
            if (setDetailTabs) {
                function isTabExists(e, item) {
                    for (const iterator of e) {
                        if (iterator.item.id === item.id) {
                            return false;
                        }
                    }
                    return true;
                }

                if (isTabExists(detailTabs, props.condition ? props.condition : item)) {
                    setDialog(props.condition ? props.condition : item);
                }
            }
        } else if (option === "Debugging") {
            // debugging
            let elem = document.getElementById("debug-icon" + index);
            if (elem !== null && elem !== undefined) {
                elem.style = "visibility:hidden";
            }
        } else if (option === "Paste Inside") {
            e.stopPropagation();
            props.options.paste(undefined, true);
        }
        handleClose(); // close
    };
    const getStyle = () => {
        let style = {top: 0, right: -3}
        if (item.action_name === 'CONDITION') {
            return {...style, right: -7};
        }
        return style;
    }
    return (
        <>
            <IconButton className="option-icon"
                        style={{position: 'absolute', zIndex: 9999, ...getStyle()}}
                        onClick={handleClick}
                        size="small"
            >
                <MoreVertIcon fontSize="small"/>
            </IconButton>
            <Menu
                style={{zIndex: 99999999}}
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        width: "12ch",
                    },
                }}
            >
                {Object.keys(options).map((option) =>
                    item.actionName === 'START' ? option === 'Paste' && <MenuItem
                        key={option}
                        style={{color: "#212F3B", fontSize: "10px", fontWeight: 600}}
                        onClick={(e) => menu(option, e)}
                    >
                        {options[option]}
                        {option}
                    </MenuItem> :
                        !isCondition ? (
                                option !== "Paste Inside" ? option === "OpenTab" ? (
                                    setDetailTabs &&
                                    <MenuItem
                                        key={option}
                                        style={{color: "#212F3B", fontSize: "10px", fontWeight: 600}}
                                        onClick={(e) => menu(option, e)}
                                    >
                                        {options[option]}
                                        {option}
                                    </MenuItem>) : (
                                    <MenuItem
                                        key={option}
                                        style={{color: "#212F3B", fontSize: "10px", fontWeight: 600}}
                                        onClick={(e) => menu(option, e)}
                                    >
                                        {options[option]}
                                        {option}
                                    </MenuItem>
                                ) : null
                            ) :
                            option === "OpenTab" ? (
                                setDetailTabs &&
                                <MenuItem
                                    key={option}
                                    style={{color: "#212F3B", fontSize: "10px", fontWeight: 600}}
                                    onClick={(e) => menu(option, e)}
                                >
                                    {options[option]}
                                    {option}
                                </MenuItem>) : (
                                <MenuItem
                                    key={option}
                                    style={{color: "#212F3B", fontSize: "10px", fontWeight: 600}}
                                    onClick={(e) => menu(option, e)}
                                >
                                    {options[option]}
                                    {option}
                                </MenuItem>
                            )
                )}
            </Menu>
        </>
    );
}

export default OptionsMenu;
